<template>
  <div
    id="clients-list"
    :class="{ 'overflow-auto': showMoreField && !desktopViewFull }"
  >
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <p>{{ loadingMessage }}</p>
    </div>

    <div v-if="showMessage" :class="['message-overlay', messageType]">
      <p>{{ messageContent }}</p>
    </div>

    <table class="table" v-if="$store.state.responsive.viewDesktopLists">
      <thead :class="{ fixheader: !showMoreField || desktopViewFull }">
      <tr>
        <th class="align-middle">
          <ThOrder
              :textHeader="'Nombre'"
              :idHeader="'name'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrderDebounced($event)"
          v-if="!$store.state.roles.Backoffice_member_empresas"
          ></ThOrder>
          <ThOrder
              :textHeader="'Nombre de compañía'"
              :idHeader="'name'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrderDebounced($event)"
          v-if="$store.state.roles.Backoffice_member_empresas"
          ></ThOrder>
        </th>
        <th
            class="align-middle"
            v-if="
              !$store.state.roles.Backoffice_member_empresas && showMoreField
            "
        >
          <ThOrder
              :textHeader="'Apellidos'"
              :idHeader="'surnames'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrderDebounced($event)"
          ></ThOrder>
        </th>
        <th
            class="align-middle"
            v-if="!$store.state.roles.Backoffice_member_empresas"
        >
          <ThOrder
              :textHeader="'DNI'"
              :idHeader="'documentNumber'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrderDebounced($event)"
          ></ThOrder>
        </th>
        <th
            class="align-middle"
            v-if="$store.state.roles.Backoffice_member_empresas"
        >
          <ThOrder
              :textHeader="'CIF'"
              :idHeader="'documentNumberCompany'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrderDebounced($event)"
          ></ThOrder>
        </th>
        <th class="align-middle">
          <ThOrder
              :textHeader="'Nº Contrato'"
              :idHeader="'contractNumber'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrderDebounced($event)"
          ></ThOrder>
        </th>
        <th
            class="align-middle"
            v-if="!$store.state.roles.Backoffice_member_empresas"
        >
          <ThOrder
              :textHeader="'Canal'"
              :idHeader="'channel'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrderDebounced($event)"
          ></ThOrder>
        </th>
        <th
            v-if="
              $store.state.roles.Backoffice_member_empresas || showMoreField
            "
            class="align-middle"
            style="min-width: 12ch !important; word-break: break-all"
        >
          <ThOrder
              :textHeader="'Email'"
              :idHeader="'email'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrderDebounced($event)"
          ></ThOrder>
        </th>
        <th class="align-middle">
          <ThOrder
              :textHeader="'Móvil'"
              :idHeader="'phone'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrderDebounced($event)"
          ></ThOrder>
        </th>
        <th class="align-middle">
          <ThOrder
              :textHeader="'Inicio contratación'"
              :idHeader="'createdDate'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrderDebounced($event)"
          ></ThOrder>
        </th>
        <th
            class="align-middle"
            v-if="
              !$store.state.roles.Backoffice_member_empresas && showMoreField
            "
        >
          <ThOrder
              :textHeader="'Tienda'"
              :idHeader="'shop'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrderDebounced($event)"
          ></ThOrder>
        </th>
        <th class="align-middle thEstado">
          <ThOrder
              :textHeader="'Estado del contrato'"
              :idHeader="'contractStatus'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrderDebounced($event)"
          ></ThOrder>
        </th>
        <th class="align-middle thOperaciones"></th>
      </tr>
      </thead>
      <tbody>
        <template v-if="!$store.state.roles.Backoffice_member_empresas">
          <tr v-for="(contract, index) in filteredContracts" :key="contract.clientId" >
            <td class="py-4 align-middle">{{ contract.customer.name }}</td>
            <td v-if="showMoreField" class="py-4 align-middle">
              {{ contract.customer.surnames }}
            </td>
            <td class="py-4 align-middle">
              {{ contract.customer.legalIdentifier }}
            </td>
            <td class="py-4 align-middle">{{ contract.contractId }}</td>
            <td class="py-4 align-middle">{{ contract.channel }}</td>
            <td
                v-if="showMoreField"
                class="py-4"
                style="min-width: 12ch !important; word-break: break-all"
            >
              {{ contract.customer.email }}
            </td>
            <td class="py-4 align-middle">{{ contract.customer.phone }}</td>
            <td class="py-4 align-middle">
              {{ $dateBackToFront(contract.date, true) }}
            </td>
            <td v-if="showMoreField" class="py-4 align-middle">
              {{ contract.storeNumber }}
            </td>
            <td
                class="py-4 align-middle tdEstado"
                style="max-width: 100%"
                :title="contract.statusDescription"
            >
              <span v-if="contract.isProcessing" class="badge badge-warning">
                <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                Procesando...
              </span>
              <span v-else :class="badgeClass(contract.status)"> <!-- Uso de método computado para clases dinámicas -->
                {{ contract.statusDescription }}
              </span>
            </td>
            <td id="operaciones" class="py-4 align-middle tdOperaciones">
              <div class="dropdown dropdown-inherit">
                <span
                    id="dropdownOperations"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                  <v-icon name="fa-ellipsis-v" />
                </span>
                <div
                    class="dropdown-menu p-0 dropdown-menu-right"
                    aria-labelledby="dropdownOperations"
                >
                  <a
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="
                      openModals(
                        index,
                        contract.contractId,
                        contract.status,
                        'contractDetail'
                      )
                    "
                  >Ver contrato</a
                  >
                  <a
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="
                      selectContractClient(
                        contract.contractId,
                        contract.status,
                        contract.customer.legalIdentifier
                      )
                    "
                    >Datos cliente</a
                  >
                  <a
                    v-if="
                      contract.status != 'PENDING_REVIEW_BO' ||
                      contract.status != 'PENDING_REVIEW_EMAIL_DUPLICATED' ||
                      contract.status != 'PENDING_REVIEW_PHONE_DUPLICATED' ||
                      contract.status != 'PENDING_REVIEW_ADDRESS_DUPLICATED'
                    "
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="
                      openModals(
                        index,
                        contract.contractId,
                        contract.status,
                        'documents'
                      )
                    "
                    >Documentos</a
                  >

                  <a
                    v-if="
                      (contract.status == 'BANK_READER_IN_PROGRESS' ||
                       contract.statusDescription == 'VALIDACIÓN DE BANKREADER EN PROGRESO') &&
                      ($store.state.roles.Backoffice_supervisor ||
                       $store.state.roles.Backoffice_member ||
                       $store.state.roles.Backoffice_admin)
                    "
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="handleBankReaderAdvance(contract.contractId)"
                    >Avanzar</a
                  >
                  <a
                    v-if="
                      contract.status == 'CONFIRMED' ||
                      contract.status == 'DESISTED' ||
                      contract.status == 'EARLY_RENEWED' ||
                      contract.status == 'FINISHED' ||
                      contract.status == 'FINISHED_AND_PURCHASE' ||
                      contract.status == 'FINISHED_EXPANSION_AND_PURCHASE' ||
                      contract.status == 'RENOVATED' ||
                      contract.status == 'UNPAID' ||
                      contract.status == 'CANCELED_STORE' ||
                      contract.status == 'CANCELED_FOR_RETURN' ||
                      contract.status == 'CANCELED_FOR_NON_PAYMENT' ||
                      contract.status == 'CANCELED_FOR_FRAUD' ||
                      contract.status == 'CANCELED_BY_CUSTOMER' ||
                      contract.status == 'CANCELED_BY_BO' ||
                      contract.status == 'CANCELED' ||
                      contract.status == 'CANCELED_BY_AGREEMENT' ||
                      contract.status == 'CANCELED_FOR_UNPAID_PLUS' ||
                      contract.status == 'RENOVATED_AND_PURCHASE' ||
                      contract.status == 'RENOVATED_EXPANSION_AND_PURCHASE' ||
                      contract.status == 'UNPAID_PLUS' ||
                      contract.status == 'CANCELED_FOR_INSURANCE_FRAUD'
                    "
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="
                      openModals(
                        index,
                        contract.contractId,
                        contract.status,
                        'payPlans'
                      )
                    "
                    >Ver planes de pago</a
                  >
                  <a
                    v-if="
                      (contract.status == 'PENDING_REVIEW_BO' ||
                        contract.status == 'PENDING_REVIEW_EMAIL_DUPLICATED' ||
                        contract.status == 'PENDING_REVIEW_PHONE_DUPLICATED' ||
                        contract.status ==
                          'PENDING_REVIEW_ADDRESS_DUPLICATED') &&
                      $store.state.roles.Backoffice_supervisor
                    "
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="
                      openModals(
                        index,
                        contract.contractId,
                        contract.status,
                        'acceptContract'
                      )
                    "
                    >Aceptar</a
                  >
                  <a
                    v-if="
                      (contract.status == 'PENDING_REVIEW_BO' ||
                        contract.status == 'PENDING_REVIEW_EMAIL_DUPLICATED' ||
                        contract.status == 'PENDING_REVIEW_PHONE_DUPLICATED' ||
                        contract.status ==
                          'PENDING_REVIEW_ADDRESS_DUPLICATED') &&
                      $store.state.roles.Backoffice_supervisor
                    "
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="
                      openModals(
                        index,
                        contract.contractId,
                        contract.status,
                        'denyContract'
                      )
                    "
                    >Denegar</a
                  >
                  <a
                    v-if="
                      (contract.status == 'PENDING_REVIEW_EMAIL_DUPLICATED' ||
                        contract.status == 'PENDING_REVIEW_PHONE_DUPLICATED' ||
                        contract.status == 'PENDING_REVIEW_ADDRESS_DUPLICATED' ||
                        contract.status == 'PENDING_REVIEW_DNI_DUPLICATED') &&
                      $store.state.roles.Backoffice_supervisor
                    "
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="handleHocelotAdvance(contract.contractId)"
                    >Avanzar H</a
                  >
                  <a
                    v-if="comprobarCancelables(contract.status)"
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="
                      openModals(
                        index,
                        contract.contractId,
                        contract.status,
                        'contractDetail'
                      )
                    "
                    >Cancelar contrato</a
                  >

                  <a
                    v-if="
                      contract.status == 'CONFIRMED' &&
                      $store.state.roles.Backoffice_supervisor
                    "
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="renewContract(contract.contractId)"
                    >Renovar contrato</a
                  >
                  <a
                    v-if="
                      contract.status == 'PENDING_CONFIRM_PAYMENT' &&
                      $store.state.roles.Backoffice_supervisor
                    "
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="sendManualSendinng(contract, 'ACCEPTED')"
                    >Aprobar envío</a
                  >
                  <a
                    v-if="
                      contract.status == 'PENDING_CONFIRM_PAYMENT' &&
                      $store.state.roles.Backoffice_supervisor
                    "
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="sendManualSendinng(contract, 'DENIED')"
                    >Denegar envío y cancelar</a
                  >
                  <a v-if="$store.state.roles.Backoffice_supervisor"
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="openModals(index, contract.contractId,contract.status,'addBL',contract)"
                    >Añadir a Black List</a>

                  <a
                      v-if="
    contract.status == 'CONFIRMED' &&
    $store.state.roles.Backoffice_member
  "
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="async () => {
    const contractDetails = await fetchAndValidateContract(contract.contractId);
    if (contractDetails) {
      contract.details = contractDetails;
      extendContract(contract);
    }
  }"
                  >Ampliar contrato</a
                  >

                  <a
                    v-if="
                      (contract.status == 'CONFIRMED' ||
                        contract.status == 'PAYMENT_CONFIRMED') &&
                      $store.state.roles.Backoffice_Superadmin
                    "
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="openModals(index, contract.contractId, contract.status, 'replacementModal', contract)"
                  >Reemplazar</a>

                  <a
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="openModals(index, contract.contractId, contract.status, 'zwipit', contract)"
                    >Trading Zwipit</a
                  >

                  <a
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="openModals(index, contract.contractId, contract.status, 'additionalChargesModal', contract)"
                    >Ver cobros adicionales</a
                  >

                  <a
                    v-if="
                      contract.status == 'PENDING_VALIDATION_SCORING_STORE' &&
                      $store.state.roles.Backoffice_supervisor
                    "
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="handleScoringStoreAction(contract.contractId, 'ACCEPTED')"
                    >Aceptar Scoring Tienda</a
                  >
                  <a
                    v-if="
                      contract.status == 'PENDING_VALIDATION_SCORING_STORE' &&
                      $store.state.roles.Backoffice_supervisor
                    "
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="handleScoringStoreAction(contract.contractId, 'DENIED')"
                    >Denegar Scoring Tienda</a
                  >
                  <a
                    v-if="
                      contract.status == 'PENDING_BIOMETRICS_ALTERNATIVE' &&
                      ($store.state.roles.Backoffice_supervisor || $store.state.roles.Backoffice_admin)
                    "
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="openModals(index, contract.contractId, contract.status, 'altBiometricsOk', contract)"
                    >BIOMETRÍA ALTERNATIVA OK</a
                  >
                  <a
                    v-if="
                      contract.status == 'PENDING_BIOMETRICS_ALTERNATIVE' &&
                      ($store.state.roles.Backoffice_supervisor || $store.state.roles.Backoffice_admin)
                    "
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="openModals(index, contract.contractId, contract.status, 'altBiometricsKo', contract)"
                    >BIOMETRÍA ALTERNATIVA KO</a
                  >
                  <a
                    v-if="
                      contract.status == 'PENDING_BIOMETRICS_ALTERNATIVE' &&
                      ($store.state.roles.Backoffice_supervisor || $store.state.roles.Backoffice_admin)
                    "
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="openModals(index, contract.contractId, contract.status, 'altBiometricsTecalis', contract)"
                    >BIOMETRÍA TECALIS</a
                  >
                </div>
              </div>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr
            v-for="(contract, index) in contractsAux"
            :key="contract.businessContractId"
          >
            <td class="py-4 align-middle">
              {{ contract.businessCustomer.name }}
            </td>
            <td class="py-4 align-middle">
              {{ contract.businessCustomer.legalIdentifier }}
            </td>
            <td class="py-4 align-middle">{{ contract.businessContractId }}</td>
            <td
              class="py-4 align-middle"
              style="min-width: 12ch !important; word-break: break-all"
            >
              {{ contract.businessCustomer.email || "-" }}
            </td>
            <td class="py-4 align-middle">
              {{ contract.businessCustomer.phone || "-" }}
            </td>
            <td class="py-4 align-middle">
              {{ $dateBackToFront(contract.transDate, true) }}
            </td>
            <td
              class="py-4 align-middle tdEstado"
              style="max-width: 100%"
              :title="contract.statusDescription"
            >
              <span v-if="contract.isProcessing" class="badge badge-warning">
                <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                Procesando...
              </span>
              <span
                v-else-if="
                  contract.status.includes('CONFIRMED') ||
                  contract.status.includes('ACCEPTED') ||
                  contract.status.includes('RENOVATED') ||
                  contract.status.includes('confirmed')
                "
                class="badge text-success border border-success"
                >{{ contract.statusDescription }}</span
              >
              <span
                v-else-if="
                  contract.status.includes('VALIDATED') ||
                  contract.status.includes('SIGNED')
                "
                class="badge text-primary border border-primary"
                >{{ contract.statusDescription }}</span
              >
              <span
                v-else-if="
                  contract.status.includes('EXPIRED') ||
                  contract.status.includes('PASSED')
                "
                class="badge text-warning border border-warning"
                >{{ contract.statusDescription }}</span
              >
              <span
                v-else-if="
                  contract.status.includes('DENIED') ||
                  contract.status.includes('CANCELED') ||
                  contract.status.includes('DISMISSED') ||
                  contract.status.includes('rejected')
                "
                class="badge text-danger border border-danger"
                >{{ contract.statusDescription }}</span
              >
              <span
                v-else-if="contract.status.includes('UNPAID')"
                class="badge border-light text-light bg-danger"
                >{{ contract.statusDescription }}</span
              >
              <span
                v-else-if="
                  contract.status.includes('PENDING') ||
                  contract.status.includes('CREATED') ||
                  contract.status.includes('pending')
                "
                class="badge text-info border border-info"
                >{{ contract.statusDescription }}</span
              >
              <span
                v-else-if="contract.status.includes('EARLY_RENEWED')"
                class="badge text-tertiary border border-tertiary"
                >{{ contract.statusDescription }}</span
              >
              <span v-else class="badge text-muted border border-dark">{{
                contract.statusDescription
              }}</span>
            </td>
            <td id="operaciones" class="py-4 align-middle tdOperaciones">
              <div class="dropdown dropdown-inherit">
                <span
                  id="dropdownOperations"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <v-icon name="fa-ellipsis-v" />
                </span>
                <div
                  class="dropdown-menu p-0 dropdown-menu-right"
                  aria-labelledby="dropdownOperations"
                >
                  <a
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="
                      openModals(
                        index,
                        contract.businessContractId,
                        contract.status,
                        'contractDetail'
                      )
                    "
                    >Ver contrato</a
                  >
                  <a
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="
                      selectContractClient(
                        contract.businessContractId,
                        contract.status,
                        contract.businessCustomer.legalIdentifier
                      )
                    "
                    >Datos cliente</a
                  >
                  <a
                    v-if="
                      contract.status != 'PENDING_REVIEW_BO' ||
                      contract.status != 'PENDING_REVIEW_EMAIL_DUPLICATED' ||
                      contract.status != 'PENDING_REVIEW_PHONE_DUPLICATED' ||
                      contract.status != 'PENDING_REVIEW_ADDRESS_DUPLICATED'
                    "
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="
                      openModals(
                        index,
                        contract.businessContractId,
                        contract.status,
                        'documents'
                      )
                    "
                    >Documentos</a
                  >

                  <a
                    v-if="
                      (contract.status == 'BANK_READER_IN_PROGRESS' ||
                       contract.statusDescription == 'VALIDACIÓN DE BANKREADER EN PROGRESO') &&
                      ($store.state.roles.Backoffice_supervisor ||
                       $store.state.roles.Backoffice_member ||
                       $store.state.roles.Backoffice_admin)
                    "
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="handleBankReaderAdvance(contract.businessContractId)"
                    >Avanzar</a
                  >
                  <a
                    v-if="
                      contract.status == 'CONFIRMED' ||
                      contract.status == 'DESISTED' ||
                      contract.status == 'EARLY_RENEWED' ||
                      contract.status == 'FINISHED' ||
                      contract.status == 'FINISHED_AND_PURCHASE' ||
                      contract.status == 'FINISHED_EXPANSION_AND_PURCHASE' ||
                      contract.status == 'RENOVATED' ||
                      contract.status == 'UNPAID' ||
                      contract.status == 'CANCELED_STORE' ||
                      contract.status == 'CANCELED_FOR_RETURN' ||
                      contract.status == 'CANCELED_FOR_NON_PAYMENT' ||
                      contract.status == 'CANCELED_FOR_FRAUD' ||
                      contract.status == 'CANCELED_BY_CUSTOMER' ||
                      contract.status == 'CANCELED_BY_BO' ||
                      contract.status == 'CANCELED' ||
                      contract.status == 'CANCELED_BY_AGREEMENT' ||
                      contract.status == 'RENOVATED_AND_PURCHASE' ||
                      contract.status == 'RENOVATED_EXPANSION_AND_PURCHASE' ||
                      contract.status == 'CANCELED_FOR_UNPAID_PLUS' ||
                      contract.status == 'UNPAID_PLUS' ||
                      contract.status == 'CANCELED_FOR_INSURANCE_FRAUD' ||
                      contract.status == 'accepted' ||
                      contract.status == 'pending_study' ||
                      contract.status == 'pending_payment' ||
                      contract.status == 'pending_payment_receipt' ||
                      contract.status == 'pending_delivery' ||
                      contract.status == 'confirmed'
                    "
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="
                      openModals(
                        index,
                        contract.businessContractId,
                        contract.status,
                        'payPlans'
                      )
                    "
                    >Ver planes de pago</a
                  >
                  <a
                    v-if="contract.status == 'pending_study'"
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="
                      openModals(
                        index,
                        contract.businessContractId,
                        contract.status,
                        'acceptContractBusiness'
                      )
                    "
                    >Aceptar</a
                  >
                  <a
                    v-if="contract.status == 'pending_study'"
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="
                      openModals(
                        index,
                        contract.businessContractId,
                        contract.status,
                        'denyContractBusiness'
                      )
                    "
                    >Denegar</a
                  >
                  <a
                    v-if="contract.status == 'pending_payment'"
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="
                      openModals(
                        index,
                        contract.businessContractId,
                        contract.status,
                        'confirmPayment'
                      )
                    "
                    >Confirmar pago</a
                  >
                  <a
                    v-if="contract.status == 'pending_payment_receipt'"
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="handlePaymentReceived(contract.businessContractId, index)"
                    >Pago recibido</a
                  >
                  <a
                    v-if="contract.status != 'canceled_by_bo'"
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="
                      openModals(
                        index,
                        contract.businessContractId,
                        contract.status,
                        'contractDetail'
                      )
                    "
                    >Cancelar contrato</a
                  >
                  <a
                    v-if="
                      contract.status == 'PENDING_CONFIRM_PAYMENT' &&
                      $store.state.roles.Backoffice_supervisor
                    "
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="sendManualSendinng(contract, 'ACCEPTED')"
                    >Aprobar envío</a
                  >
                  <a
                    v-if="
                      contract.status == 'PENDING_CONFIRM_PAYMENT' &&
                      $store.state.roles.Backoffice_supervisor
                    "
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="sendManualSendinng(contract, 'DENIED')"
                    >Denegar envío y cancelar</a
                  >

                  <a
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="openModals(index, contract.businessContractId, contract.status, 'zwipit', contract)"
                    >Trading Zwipit</a
                  >

                  <a
                    class="dropdown-item py-3 px-4"
                    href="#"
                    @click="openModals(index, contract.businessContractId, contract.status, 'additionalChargesModal', contract)"
                    >Ver cobros adicionales</a
                  >
                </div>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <template
      v-if="
        !$store.state.responsive.viewDesktopLists &&
        !$store.state.roles.Backoffice_member_empresas
      "
    >
      <div
        class="card p-2 mb-3"
        v-for="(contract, index) in contractsAux"
        :key="contract.clientId"
      >
        <div class="list-item">
          <div
            class="item d-flex align-items-center justify-content-between px-2 py-3"
            data-toggle="collapse"
            :href="'#collapseExample' + index"
            role="button"
            aria-expanded="true"
            :aria-controls="'collapseExample' + index"
          >
            <h4 class="m-0">
              {{ contract.customer.name }} {{ contract.customer.surnames }} -
              {{ contract.customer.legalIdentifier }} -
              {{ contract.contractId }}
            </h4>
            <v-icon name="bi-chevron-up" />
          </div>
          <div
            class="collapse show ml-3 mr-2 borderFirstItem"
            :id="'collapseExample' + index"
          >
            <div
              class="d-flex align-items-center justify-content-between flex-wrap mb-2 mt-2"
            >
              <div class="d-flex align-items-center justify-content-start">
                <p class="m-0 mr-2">
                  <strong>Nombre: </strong>{{ contract.customer.name }}
                </p>
              </div>
              <div>
                <div class="dropdown dropdown-inherit">
                  <span
                    id="dropdownOperations"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <v-icon name="fa-ellipsis-v" />
                  </span>
                  <div
                    class="dropdown-menu p-0 dropdown-menu-right"
                    aria-labelledby="dropdownOperations"
                  >
                    <a
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="
                        openModals(
                          index,
                          contract.contractId,
                          contract.status,
                          'contractDetail'
                        )
                      "
                      >Ver contrato</a
                    >
                    <a
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="
                        selectContractClient(
                          contract.contractId,
                          contract.status,
                          contract.customer.legalIdentifier
                        )
                      "
                      >Datos cliente</a
                    >
                    <a
                      v-if="
                        contract.status != 'PENDING_REVIEW_BO' ||
                        contract.status != 'PENDING_REVIEW_EMAIL_DUPLICATED' ||
                        contract.status != 'PENDING_REVIEW_PHONE_DUPLICATED' ||
                        contract.status != 'PENDING_REVIEW_ADDRESS_DUPLICATED'
                      "
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="
                        openModals(
                          index,
                          contract.contractId,
                          contract.status,
                          'documents'
                        )
                      "
                      >Documentos</a
                    >

                    <a
                      v-if="
                        (contract.status == 'BANK_READER_IN_PROGRESS' ||
                         contract.statusDescription == 'VALIDACIÓN DE BANKREADER EN PROGRESO') &&
                        ($store.state.roles.Backoffice_supervisor ||
                         $store.state.roles.Backoffice_member ||
                         $store.state.roles.Backoffice_admin)
                      "
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="handleBankReaderAdvance(contract.contractId)"
                      >Avanzar</a
                    >


                    <a
                      v-if="
                        contract.status == 'CONFIRMED' ||
                        contract.status == 'DESISTED' ||
                        contract.status == 'EARLY_RENEWED' ||
                        contract.status == 'FINISHED' ||
                        contract.status == 'FINISHED_AND_PURCHASE' ||
                        contract.status == 'FINISHED_EXPANSION_AND_PURCHASE' ||
                        contract.status == 'RENOVATED' ||
                        contract.status == 'UNPAID' ||
                        contract.status == 'CANCELED_STORE' ||
                        contract.status == 'CANCELED_FOR_RETURN' ||
                        contract.status == 'CANCELED_FOR_NON_PAYMENT' ||
                        contract.status == 'CANCELED_FOR_FRAUD' ||
                        contract.status == 'CANCELED_BY_CUSTOMER' ||
                        contract.status == 'CANCELED_BY_BO' ||
                        contract.status == 'CANCELED' ||
                        contract.status == 'CANCELED_BY_AGREEMENT' ||
                        contract.status == 'RENOVATED_AND_PURCHASE' ||
                        contract.status == 'RENOVATED_EXPANSION_AND_PURCHASE' ||
                        contract.status == 'CANCELED_FOR_UNPAID_PLUS' ||
                        contract.status == 'UNPAID_PLUS' ||
                        contract.status == 'CANCELED_FOR_INSURANCE_FRAUD'
                      "
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="
                        openModals(
                          index,
                          contract.contractId,
                          contract.status,
                          'payPlans'
                        )
                      "
                      >Ver planes de pago</a
                    >
                    <a
                      v-if="
                        (contract.status == 'PENDING_REVIEW_BO' ||
                          contract.status ==
                            'PENDING_REVIEW_EMAIL_DUPLICATED' ||
                          contract.status ==
                            'PENDING_REVIEW_PHONE_DUPLICATED' ||
                          contract.status ==
                            'PENDING_REVIEW_ADDRESS_DUPLICATED') &&
                        $store.state.roles.Backoffice_supervisor
                      "
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="
                        openModals(
                          index,
                          contract.contractId,
                          contract.status,
                          'acceptContract'
                        )
                      "
                      >Aceptar</a
                    >
                    <a
                      v-if="
                        (contract.status == 'PENDING_REVIEW_BO' ||
                          contract.status ==
                            'PENDING_REVIEW_EMAIL_DUPLICATED' ||
                          contract.status ==
                            'PENDING_REVIEW_PHONE_DUPLICATED' ||
                          contract.status ==
                            'PENDING_REVIEW_ADDRESS_DUPLICATED') &&
                        $store.state.roles.Backoffice_supervisor
                      "
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="
                        openModals(
                          index,
                          contract.contractId,
                          contract.status,
                          'denyContract'
                        )
                      "
                      >Denegar</a
                    >
                    <a
                      v-if="
                        (contract.status == 'PENDING_REVIEW_EMAIL_DUPLICATED' ||
                          contract.status == 'PENDING_REVIEW_PHONE_DUPLICATED' ||
                          contract.status == 'PENDING_REVIEW_ADDRESS_DUPLICATED' ||
                          contract.status == 'PENDING_REVIEW_DNI_DUPLICATED') &&
                        $store.state.roles.Backoffice_supervisor
                      "
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="handleHocelotAdvance(contract.contractId)"
                      >Avanzar H</a
                    >
                    <a
                      v-if="comprobarCancelables(contract.status)"
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="
                        openModals(
                          index,
                          contract.contractId,
                          contract.status,
                          'contractDetail'
                        )
                      "
                      >Cancelar contrato</a
                    >
                    <a
                      v-if="
                        contract.status == 'CONFIRMED' &&
                        $store.state.roles.Backoffice_supervisor
                      "
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="renewContract(contract.contractId)"
                      >Renovar contrato</a
                    >
                    <a
                      v-if="
                        contract.status == 'PENDING_CONFIRM_PAYMENT' &&
                        $store.state.roles.Backoffice_supervisor
                      "
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="sendManualSendinng(contract, 'ACCEPTED')"
                      >Aprobar envío</a
                    >
                    <a
                      v-if="
                        contract.status == 'PENDING_CONFIRM_PAYMENT' &&
                        $store.state.roles.Backoffice_supervisor
                      "
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="sendManualSendinng(contract, 'DENIED')"
                      >Denegar envío y cancelar</a
                    >
                    <a v-if="$store.state.roles.Backoffice_supervisor"
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="openModals(index, contract.contractId,contract.status,'addBL',contract)"
                      >Añadir a Black List</a>

                    <a
                      v-if="
                        (contract.status == 'CONFIRMED' ||
                          contract.status == 'PAYMENT_CONFIRMED') &&
                        $store.state.roles.Backoffice_Superadmin
                      "
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="openModals(index, contract.contractId, contract.status, 'replacementModal', contract)"
                      >Reemplazar</a>

                    <a
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="openModals(index, contract.contractId, contract.status, 'zwipit', contract)"
                      >Trading Zwipit</a
                    >

                    <a
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="openModals(index, contract.contractId, contract.status, 'additionalChargesModal', contract)"
                      >Ver cobros adicionales</a
                    >

                    <a
                      v-if="
                        contract.status == 'PENDING_VALIDATION_SCORING_STORE' &&
                        $store.state.roles.Backoffice_supervisor
                      "
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="handleScoringStoreAction(contract.contractId, 'ACCEPTED')"
                      >Aceptar Scoring Tienda</a
                    >
                    <a
                      v-if="
                        contract.status == 'PENDING_VALIDATION_SCORING_STORE' &&
                        $store.state.roles.Backoffice_supervisor
                      "
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="handleScoringStoreAction(contract.contractId, 'DENIED')"
                      >Denegar Scoring Tienda</a
                    >
                    <a
                      v-if="
                        contract.status == 'PENDING_BIOMETRICS_ALTERNATIVE' &&
                        ($store.state.roles.Backoffice_supervisor || $store.state.roles.Backoffice_admin)
                      "
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="openModals(index, contract.contractId, contract.status, 'altBiometricsOk', contract)"
                      >BIOMETRÍA ALTERNATIVA OK</a
                    >
                    <a
                      v-if="
                        contract.status == 'PENDING_BIOMETRICS_ALTERNATIVE' &&
                        ($store.state.roles.Backoffice_supervisor || $store.state.roles.Backoffice_admin)
                      "
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="openModals(index, contract.contractId, contract.status, 'altBiometricsKo', contract)"
                      >BIOMETRÍA ALTERNATIVA KO</a
                    >
                    <a
                      v-if="
                        contract.status == 'PENDING_BIOMETRICS_ALTERNATIVE' &&
                        ($store.state.roles.Backoffice_supervisor || $store.state.roles.Backoffice_admin)
                      "
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="openModals(index, contract.contractId, contract.status, 'altBiometricsTecalis', contract)"
                      >BIOMETRÍA TECALIS</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div
              class="d-flex align-items-center justify-content-start flex-wrap mb-2"
            >
              <p class="m-0 mr-2">
                <strong>Apellidos: </strong>{{ contract.customer.surnames }}
              </p>
            </div>
            <div
              class="d-flex align-items-center justify-content-start flex-wrap mb-2"
            >
              <p class="m-0 mr-2">
                <strong>DNI: </strong>{{ contract.customer.legalIdentifier }}
              </p>
            </div>
            <div
              class="d-flex align-items-center justify-content-start flex-wrap mb-2"
            >
              <p class="m-0 mr-2">
                <strong>Nº Contrato: </strong>{{ contract.contractId }}
              </p>
            </div>
            <div
              class="d-flex align-items-center justify-content-start flex-wrap mb-2"
            >
              <p class="m-0 mr-2">
                <strong>Canal: </strong>{{ contract.channel }}
              </p>
            </div>
            <div
              class="d-flex align-items-center justify-content-start flex-wrap mb-2"
            >
              <p class="m-0 mr-2">
                <strong>Email: </strong>{{ contract.customer.email }}
              </p>
            </div>
            <div
              class="d-flex align-items-center justify-content-start flex-wrap mb-2"
            >
              <p class="m-0 mr-2">
                <strong>Móvil: </strong>{{ contract.customer.phone }}
              </p>
            </div>
            <div
              class="d-flex align-items-center justify-content-start flex-wrap mb-2"
            >
              <p class="m-0 mr-2">
                <strong>Inicio contratación: </strong
                >{{ $dateBackToFront(contract.date, true) }}
              </p>
            </div>
            <div
              class="d-flex align-items-center justify-content-start flex-wrap mb-2"
            >
              <p class="m-0 mr-2">
                <strong>Tienda: </strong>{{ contract.storeNumber }}
              </p>
            </div>
            <div
              class="d-flex align-items-center justify-content-start flex-wrap mb-2"
            >
              <p class="m-0 mr-2"><strong>Estado: </strong></p>
              <span
                v-if="
                  contract.status.includes('CONFIRMED') ||
                  contract.status.includes('ACCEPTED') ||
                  contract.status.includes('RENOVATED') ||
                  contract.status.includes('RECEIVED')
                "
                class="badge text-success border border-success"
                >{{ contract.statusDescription }}</span
              >
              <span
                v-else-if="
                  contract.status.includes('VALIDATED') ||
                  contract.status.includes('SIGNED')
                "
                class="badge text-primary border border-primary"
                >{{ contract.statusDescription }}</span
              >
              <span
                v-else-if="
                  contract.status.includes('EXPIRED') ||
                  contract.status.includes('PASSED')
                "
                class="badge text-warning border border-warning"
                >{{ contract.statusDescription }}</span
              >
              <span
                v-else-if="
                  contract.status.includes('DENIED') ||
                  contract.status.includes('CANCELED') ||
                  contract.status.includes('DISMISSED')
                "
                class="badge text-danger border border-danger"
                >{{ contract.statusDescription }}</span
              >
              <span
                v-else-if="contract.status.includes('UNPAID')"
                class="badge border-light text-light bg-danger"
                >{{ contract.statusDescription }}</span
              >
              <span
                v-else-if="
                  contract.status.includes('PENDING') ||
                  contract.status.includes('CREATED')
                "
                class="badge text-info border border-info"
                >{{ contract.statusDescription }}</span
              >
              <span
                v-else-if="contract.status.includes('EARLY_RENEWED')"
                class="badge text-tertiary border border-tertiary"
                >{{ contract.statusDescription }}</span
              >
              <span v-else class="badge text-muted border border-dark">{{
                contract.statusDescription
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template
      v-if="
        !$store.state.responsive.viewDesktopLists &&
        $store.state.roles.Backoffice_member_empresas
      "
    >
      <div
        class="card p-2 mb-3"
        v-for="(contract, index) in contractsAux"
        :key="contract.businessContractId"
      >
        <div class="list-item">
          <div
            class="item d-flex align-items-center justify-content-between px-2 py-3"
            data-toggle="collapse"
            :href="'#collapseExample' + index"
            role="button"
            aria-expanded="true"
            :aria-controls="'collapseExample' + index"
          >
            <h4 class="m-0">
              {{ contract.businessCustomer.name }} -
              {{ contract.businessCustomer.legalIdentifier }} -
              {{ contract.businessContractId }}
            </h4>
            <v-icon name="bi-chevron-up" />
          </div>
          <div
            class="collapse show ml-3 mr-2 borderFirstItem"
            :id="'collapseExample' + index"
          >
            <div
              class="d-flex align-items-center justify-content-between flex-wrap mb-2 mt-2"
            >
              <div class="d-flex align-items-center justify-content-start">
                <p class="m-0 mr-2">
                  <strong>Nombre compañía: </strong
                  >{{ contract.businessCustomer.name }}
                </p>
              </div>
              <div>
                <div class="dropdown dropdown-inherit">
                  <span
                    id="dropdownOperations"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <v-icon name="fa-ellipsis-v" />
                  </span>
                  <div
                    class="dropdown-menu p-0 dropdown-menu-right"
                    aria-labelledby="dropdownOperations"
                  >
                    <a
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="
                        openModals(
                          index,
                          contract.businessContractId,
                          contract.status,
                          'contractDetail'
                        )
                      "
                      >Ver contrato</a
                    >
                    <a
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="
                        selectContractClient(
                          contract.businessContractId,
                          contract.status,
                          contract.businessCustomer.legalIdentifier
                        )
                      "
                      >Datos cliente</a
                    >
                    <a
                      v-if="
                        contract.status != 'PENDING_REVIEW_BO' ||
                        contract.status != 'PENDING_REVIEW_EMAIL_DUPLICATED' ||
                        contract.status != 'PENDING_REVIEW_PHONE_DUPLICATED' ||
                        contract.status != 'PENDING_REVIEW_ADDRESS_DUPLICATED'
                      "
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="
                        openModals(
                          index,
                          contract.businessContractId,
                          contract.status,
                          'documents'
                        )
                      "
                      >Documentos</a
                    >

                    <a
                      v-if="
                        (contract.status == 'BANK_READER_IN_PROGRESS' ||
                         contract.statusDescription == 'VALIDACIÓN DE BANKREADER EN PROGRESO') &&
                        ($store.state.roles.Backoffice_supervisor ||
                         $store.state.roles.Backoffice_member ||
                         $store.state.roles.Backoffice_admin)
                      "
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="handleBankReaderAdvance(contract.businessContractId)"
                      >Avanzar</a
                    >
                    <a
                      v-if="
                        contract.status == 'CONFIRMED' ||
                        contract.status == 'DESISTED' ||
                        contract.status == 'EARLY_RENEWED' ||
                        contract.status == 'FINISHED' ||
                        contract.status == 'FINISHED_AND_PURCHASE' ||
                        contract.status == 'FINISHED_EXPANSION_AND_PURCHASE' ||
                        contract.status == 'RENOVATED' ||
                        contract.status == 'UNPAID' ||
                        contract.status == 'CANCELED_STORE' ||
                        contract.status == 'CANCELED_FOR_RETURN' ||
                        contract.status == 'CANCELED_FOR_NON_PAYMENT' ||
                        contract.status == 'CANCELED_FOR_FRAUD' ||
                        contract.status == 'CANCELED_BY_CUSTOMER' ||
                        contract.status == 'CANCELED_BY_BO' ||
                        contract.status == 'CANCELED' ||
                        contract.status == 'CANCELED_BY_AGREEMENT' ||
                        contract.status == 'RENOVATED_AND_PURCHASE' ||
                        contract.status == 'RENOVATED_EXPANSION_AND_PURCHASE' ||
                        contract.status == 'CANCELED_FOR_UNPAID_PLUS' ||
                        contract.status == 'UNPAID_PLUS' ||
                        contract.status == 'CANCELED_FOR_INSURANCE_FRAUD' ||
                        contract.status == 'accepted' ||
                        contract.status == 'pending_study' ||
                        contract.status == 'pending_payment' ||
                        contract.status == 'pending_payment_receipt' ||
                        contract.status == 'pending_delivery' ||
                        contract.status == 'confirmed'
                      "
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="
                        openModals(
                          index,
                          contract.businessContractId,
                          contract.status,
                          'payPlans'
                        )
                      "
                      >Ver planes de pago</a
                    >
                    <a
                      v-if="contract.status == 'pending_study'"
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="
                        openModals(
                          index,
                          contract.businessContractId,
                          contract.status,
                          'acceptContractBusiness'
                        )
                      "
                      >Aceptar</a
                    >
                    <a
                      v-if="contract.status == 'pending_study'"
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="
                        openModals(
                          index,
                          contract.businessContractId,
                          contract.status,
                          'denyContractBusiness'
                        )
                      "
                      >Denegar</a
                    >
                    <a
                      v-if="contract.status == 'pending_payment'"
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="
                        openModals(
                          index,
                          contract.businessContractId,
                          contract.status,
                          'confirmPayment'
                        )
                      "
                      >Confirmar pago</a
                    >
                    <a
                      v-if="contract.status == 'pending_payment_receipt'"
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="handlePaymentReceived(contract.businessContractId, index)"
                      >Pago recibido</a
                    >
                    <a
                      v-if="contract.status != 'canceled_by_bo'"
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="
                        openModals(
                          index,
                          contract.businessContractId,
                          contract.status,
                          'contractDetail'
                        )
                      "
                      >Cancelar contrato</a
                    >
                    <a
                      v-if="
                        contract.status == 'PENDING_CONFIRM_PAYMENT' &&
                        $store.state.roles.Backoffice_supervisor
                      "
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="sendManualSendinng(contract, 'ACCEPTED')"
                      >Aprobar envío</a
                    >
                    <a
                      v-if="
                        contract.status == 'PENDING_CONFIRM_PAYMENT' &&
                        $store.state.roles.Backoffice_supervisor
                      "
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="sendManualSendinng(contract, 'DENIED')"
                      >Denegar envío y cancelar</a
                    >

                    <a
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="openModals(index, contract.businessContractId, contract.status, 'zwipit', contract)"
                      >Trading Zwipit</a
                    >

                    <a
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="openModals(index, contract.businessContractId, contract.status, 'additionalChargesModal', contract)"
                      >Ver cobros adicionales</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div
              class="d-flex align-items-center justify-content-start flex-wrap mb-2"
            >
              <p class="m-0 mr-2">
                <strong>CIF: </strong
                >{{ contract.businessCustomer.legalIdentifier }}
              </p>
            </div>
            <div
              class="d-flex align-items-center justify-content-start flex-wrap mb-2"
            >
              <p class="m-0 mr-2">
                <strong>Nº Contrato: </strong>{{ contract.businessContractId }}
              </p>
            </div>
            <div
              class="d-flex align-items-center justify-content-start flex-wrap mb-2"
            >
              <p class="m-0 mr-2">
                <strong>Email: </strong
                >{{ contract.businessCustomer.email || "-" }}
              </p>
            </div>
            <div
              class="d-flex align-items-center justify-content-start flex-wrap mb-2"
            >
              <p class="m-0 mr-2">
                <strong>Móvil: </strong
                >{{ contract.businessCustomer.phone || "-" }}
              </p>
            </div>
            <div
              class="d-flex align-items-center justify-content-start flex-wrap mb-2"
            >
              <p class="m-0 mr-2">
                <strong>Inicio contratación: </strong
                >{{ $dateBackToFront(contract.transDate, true) }}
              </p>
            </div>
            <div
              class="d-flex align-items-center justify-content-start flex-wrap mb-2"
            >
              <p class="m-0 mr-2"><strong>Estado: </strong></p>
              <span
                v-if="
                  contract.status.includes('CONFIRMED') ||
                  contract.status.includes('ACCEPTED') ||
                  contract.status.includes('RENOVATED') ||
                  contract.status.includes('confirmed')
                "
                class="badge text-success border border-success"
                >{{ contract.statusDescription }}</span
              >
              <span
                v-else-if="
                  contract.status.includes('VALIDATED') ||
                  contract.status.includes('SIGNED')
                "
                class="badge text-primary border border-primary"
                >{{ contract.statusDescription }}</span
              >
              <span
                v-else-if="
                  contract.status.includes('EXPIRED') ||
                  contract.status.includes('PASSED')
                "
                class="badge text-warning border border-warning"
                >{{ contract.statusDescription }}</span
              >
              <span
                v-else-if="
                  contract.status.includes('DENIED') ||
                  contract.status.includes('CANCELED') ||
                  contract.status.includes('DISMISSED') ||
                  contract.status.includes('rejected')
                "
                class="badge text-danger border border-danger"
                >{{ contract.statusDescription }}</span
              >
              <span
                v-else-if="contract.status.includes('UNPAID')"
                class="badge border-light text-light bg-danger"
                >{{ contract.statusDescription }}</span
              >
              <span
                v-else-if="
                  contract.status.includes('PENDING') ||
                  contract.status.includes('CREATED') ||
                  contract.status.includes('pending')
                "
                class="badge text-info border border-info"
                >{{ contract.statusDescription }}</span
              >
              <span
                v-else-if="contract.status.includes('EARLY_RENEWED')"
                class="badge text-tertiary border border-tertiary"
                >{{ contract.statusDescription }}</span
              >
              <span v-else class="badge text-muted border border-dark">{{
                contract.statusDescription
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <ContractDetail
      v-if="showModalContractDetail"
      :contractIndex="contractIndex"
      :contractId="contractSelected"
      :contractStatus="contractStatus"
      @closeModal="showModalContractDetail = false"
      @statusUpdated="updateContractStatus"
      :cancelables="cancelables"
      :id="'contractDetail'"
      :modalTitle="'INFORMACIÓN DEL CONTRATO'"
      :class="'modal-xl'"
      @refreshContractList="refreshContractList($event)"
    ></ContractDetail>
    <PayPlans
      v-if="showModalPayPlans"
      :contractId="contractSelected"
      :id="'payPlans'"
      :modalTitle="'PLANES DE PAGO'"
      :class="'modal-lg'"
      @closeModal="showModalPayPlans = false"
    >
    </PayPlans>
    <ClientDataDetail
      :clientInfo="clientInfo"
      :contractId="contractSelected"
      :id="'clientDataDetail'"
      :modalTitle="'INFORMACIÓN DEL CLIENTE'"
      :class="'modal-xl'"
    ></ClientDataDetail>
    <Documents
      v-if="showModalDocuments"
      :contractId="contractSelected"
      :id="'documents'"
      :modalTitle="'DOCUMENTOS'"
      :class="'modal-xl'"
      @closeModal="showModalDocuments = false"
    >
    </Documents>
    <AcceptContract
      :contractIndex="contractIndex"
      :contractId="contractSelected"
      :id="'acceptContract'"
      :modalTitle="'ACEPTAR REVISIÓN'"
      :class="'modal-md'"
      :business="false"
      @refreshContractList="refreshContractList($event)"
    >
    </AcceptContract>
    <AcceptContract
      :contractIndex="contractIndex"
      :contractId="contractSelected"
      :id="'acceptContractBusiness'"
      :modalTitle="'ACEPTAR GESTIÓN'"
      :class="'modal-md'"
      :business="true"
      @refreshContractList="refreshContractList($event)"
    >
    </AcceptContract>
    <DenyContract
      :contractIndex="contractIndex"
      :contractId="contractSelected"
      :id="'denyContract'"
      :modalTitle="'DENEGAR REVISIÓN'"
      :class="'modal-md'"
      :business="false"
      @refreshContractList="refreshContractList($event)"
    >
    </DenyContract>
    <DenyContract
      :contractIndex="contractIndex"
      :contractId="contractSelected"
      :id="'denyContractBusiness'"
      :modalTitle="'DENEGAR GESTIÓN'"
      :class="'modal-md'"
      :business="true"
      @refreshContractList="refreshContractList($event)"
    >
    </DenyContract>
    <DenyBLContract
      :contractIndex="contractIndex"
      :contractId="contractSelected"
      :id="'denyBLContract'"
      :modalTitle="'DENEGAR REVISIÓN Y AÑADIR A LA BLACK LIST'"
      :class="'modal-md'"
      @refreshContractList="refreshContractList($event)"
    >
    </DenyBLContract>
    <ConfirmPayment
      v-if="showModalConfirmPayment"
      :contractIndex="contractIndex"
      :contractId="contractSelected"
      :id="'confirmPayment'"
      @closeModal="showModalConfirmPayment = false"
      :modalTitle="'CONFIRMAR PAGO'"
      :class="'modal-md'"
      @refreshContractList="refreshContractList($event)"
    >
    </ConfirmPayment>
    <ModalError
      :id="'modalError'"
      :modalTitle="'SE HA PRODUCIDO UN ERROR'"
      :class="'modal'"
      :showFooter="false"
      :message="errorMessage"
      :code="errorCode"
    />
    <ModalSuccess
      :id="'modalSuccess'"
      :modalTitle="'SE HA ENVIADO CORRECTAMENTE'"
      :class="'modal'"
      :showFooter="false"
      :message="sucessMessage"
    />
    <AddBL
      v-if="showModalAddBL"
      :id="'addBL'"
      :email="addBL_email"
      :legalIdentifier="addBL_legalIdentifier"
      :phone="addBL_phone"
      :modalTitle="'AÑADIR A BLACK LIST'"
      :class="'modal-xl'"
      @closeModal="showModalAddBL = false;addBL_email = '';addBL_legalIdentifier = ''; addBL_phone = ''"
    >
    </AddBL>
    <ZwipitModal
      v-if="showModalZwipit"
      :id="'zwipit'"
      :modalTitle="'Trading Zwipit'"
      :legalIdentifier="zwipit_legalIdentifier"
      @closeModal="showModalZwipit = false; zwipit_legalIdentifier=''"
    >
    </ZwipitModal>
    <AdditionalChargesModal
      v-if="showModalAdditionalCharges"
      :contractId="contractSelected"
      @closeModal="showModalAdditionalCharges = false"
      :id="'additionalChargesModal'"
      :modalTitle="'COBROS ADICIONALES'"
      :class="'modal-xl'"
    />
    <ModalReplacement
      v-if="showModalReplacement"
      :contractId="contractSelected"
      :contractIndex="contractIndex"
      @closeModal="showModalReplacement = false"
      @replacementSuccess="handleReplacementSuccess"
      :id="'replacementModal'"
      :modalTitle="'REEMPLAZO DE PRODUCTO'"
      :class="'modal-xl'"
    />
    <AlternativeBiometricsAction
      :contractId="contractSelected"
      :id="'altBiometricsOk'"
      :modalTitle="'BIOMETRÍA ALTERNATIVA OK'"
      :class="'modal-md'"
      :actionType="'ok'"
      @refrestContractList="$emit('refrestContractList', $event)"
    />
    <AlternativeBiometricsAction
      :contractId="contractSelected"
      :id="'altBiometricsKo'"
      :modalTitle="'BIOMETRÍA ALTERNATIVA KO'"
      :class="'modal-md'"
      :actionType="'ko'"
      @refrestContractList="$emit('refrestContractList', $event)"
    />
    <AlternativeBiometricsAction
      :contractId="contractSelected"
      :id="'altBiometricsTecalis'"
      :modalTitle="'BIOMETRÍA TECALIS'"
      :class="'modal-md'"
      :actionType="'tecalis'"
      @refrestContractList="$emit('refrestContractList', $event)"
    />
  </div>
</template>

<script>
import ContractDetail from "./ContractDetail.vue"
import ClientDataDetail from "./ClientDataDetail.vue"
import Documents from "./Documents.vue"
import PayPlans from "./PayPlans.vue"
import AcceptContract from "./AcceptContract.vue"
import DenyContract from "./DenyContract.vue"
import ConfirmPayment from "./ConfirmPayment.vue"
import DenyBLContract from "./DenyBLContract.vue"
import ThOrder from "../../../Shared/ThOrder.vue"
import ModalError from "../../../Shared/ModalError.vue"
import ModalSuccess from "../../../Shared/ModalSuccess.vue"
import AddBL from "./AddBL.vue"
import ZwipitModal from "./ZwipitModal.vue"
import AdditionalChargesModal from "./AdditionalChargesModal.vue"
import ModalReplacement from "./ModalReplacement.vue"
import AlternativeBiometricsAction from "./AlternativeBiometricsAction.vue"
import axios from "axios"
import { Modal as ModalBootstrap } from "bootstrap"
import {debounce} from "chart.js/helpers";

export default {
  name: "ContractsList",
  props: ["contracts", "showMoreField", "desktopViewFull"],
  data() {
    return {
      currentOrder: "",
      currentOrderBy: "",
      contractSelected: "",
      contractStatus: "",
      contractIndex: "",
      contractsAux: this.contracts,
      legalIdentifierSelected: "",
      clientInfo: "",
      sucessMessage: undefined,
      cancelables: [
        "VALIDATED",
        "CONTRACT_PROCESSED",
        "BANK_READER_IN_PROGRESS",
        "SMS_SENT_BIOMETRICS",
        "SCORING_PASSED",
        "PENDING_SCORING",
        "PENDING_VALIDATION_SCORING_STORE",
        "DENIED_SCORING_STORE",
        "RESERVED",
        "PENDING_VALIDATE_DUPLICATES",
        "PENDING_REVIEW_PHONE_DUPLICATED",
        "PENDING_REVIEW_EMAIL_DUPLICATED",
        "PENDING_REVIEW_ADDRESS_DUPLICATED",
        "PENDING_REVIEW_BO",
        "PENDING_VALIDATION",
        "PENDING_POLICY_MISSING_INFO",
        "PENDING_RESERVE",
        "PENDING_IMEI",
        "PENDING_SIGNATURE_DELIVERY_DOCUMENT",
        "PENDING_SIGNATURE",
        "PENDING_SEND_DELIVERY_DOCUMENT",
        "PENDING_STORE_CLOSE",
        "PENDING_SAVE_DELIVERY_DOCUMENT",
        "PENDING_POLICY",
        "PENDING_CONFIRM_PAYMENT",
        "PENDING_BIOMETRICS",
        "ORDER_REQUESTED",
        "PENDING_PAYMENT",
        "PAYMENT_CONFIRMED",
        "IMEI_CONFIRMED_STORE",
        "SIGNED",
        "CREATED",
        "CONTRACTED",
        "BANK_READER_OK",
        "ACCEPTED",
        "UNPAID",
        "DESISTED_PENDING_RECEIVE",
        "CONFIRMED",
        "RENOVATED_AND_PURCHASE",
        "FINISHED_AND_PURCHASE",
        "FINISHED",
        "FINISHED_EXPANSION_AND_PURCHASE"
      ],
      showModalPayPlans: false,
      showModalDocuments: false,
      showModalConfirmPayment: false,
      showModalContractDetail: false,
      showModalAddBL: false,
      addBL_email: '',
      addBL_legalIdentifier: '',
      addBL_phone: '',
      isLoading: false,
      loadingMessage: "",
      showMessage: false,
      messageType: "",
      messageContent: "",
      showModalZwipit: false,
      zwipit_legalIdentifier: '',
      showModalAdditionalCharges: false,
      showModalReplacement: false,
    }
  },
  updated() {
    this.contractsAux = this.contracts
  },
  components: {
    ContractDetail,
    ClientDataDetail,
    Documents,
    PayPlans,
    AcceptContract,
    DenyContract,
    DenyBLContract,
    ThOrder,
    ConfirmPayment,
    ModalError,
    ModalSuccess,
    AddBL,
    ZwipitModal,
    AdditionalChargesModal,
    ModalReplacement,
    AlternativeBiometricsAction,
  },
  computed: {
    badgeClass() {
      return (status) => {
        if (
            status.includes("CONFIRMED") ||
            status.includes("ACCEPTED") ||
            status.includes("RENOVATED")
        ) {
          return "badge text-success border border-success";
        }
        if (status.includes("VALIDATED") || status.includes("SIGNED")) {
          return "badge text-primary border border-primary";
        }
        if (status.includes("EXPIRED") || status.includes("PASSED")) {
          return "badge text-warning border border-warning";
        }
        if (
            status.includes("DENIED") ||
            status.includes("CANCELED") ||
            status.includes("DISMISSED")
        ) {
          return "badge text-danger border border-danger";
        }
        if (status.includes("UNPAID")) {
          return "badge border-light text-light bg-danger";
        }
        if (
            status.includes("PENDING") ||
            status.includes("CREATED")
        ) {
          return "badge text-info border border-info";
        }
        if (status.includes("EARLY_RENEWED")) {
          return "badge text-tertiary border border-tertiary";
        }
        return "badge text-muted border border-dark";
      };
    },
    filteredContracts() {
      return this.contractsAux;
    },
  },
  methods: {
    selectOrder(value) {

      this.contractsAux.sort((a, b) => {
        let valorA = a[value.orderBy] || 0;
        let valorB = b[value.orderBy] || 0;

        if (value.orderBy === "capacity") {
          valorA = parseInt(valorA.slice(0, -2));
          valorB = parseInt(valorB.slice(0, -2));
        }
        return valorA < valorB ? -1 : valorA > valorB ? 1 : 0;
      });

      if (value.order === "DESC") {
        this.contractsAux.reverse();
      }
    },
    debounce(fn, delay) {
      let timeoutID = null;
      return function () {
        clearTimeout(timeoutID);
        let args = arguments;
        timeoutID = setTimeout(() => {
          fn.apply(this, args);
        }, delay);
      };
    },
    selectOrderDebounced: debounce(function (value) {
      this.selectOrder(value);
    }, 300),
    openModals(index, id, status, identifier, contract) {

      this.contractIndex = index;
      this.contractSelected = id;
      this.contractStatus = status;

      switch (identifier) {
        case "payPlans":
          this.showModalPayPlans = true;
          break;
        case "documents":
          this.showModalDocuments = true;
          break;
        case "confirmPayment":
          this.showModalConfirmPayment = true;
          break;
        case "contractDetail":
          this.showModalContractDetail = true;
          break;
        case "addBL":
          this.showModalAddBL = true;
          this.addBL_email = contract.customer.email;
          this.addBL_legalIdentifier = contract.customer.legalIdentifier;
          this.addBL_phone = contract.customer.phone;
          break;
        case "zwipit":
          this.showModalZwipit = true;
          this.zwipit_legalIdentifier = contract.customer ? contract.customer.legalIdentifier : contract.businessCustomer.legalIdentifier;
          break;
        case "additionalChargesModal":
          this.showModalAdditionalCharges = true;
          break;
        case "replacementModal":
          this.showModalReplacement = true;
          break;
      }
      this.$nextTick(() => {
        var myModal = new ModalBootstrap(document.getElementById(identifier))
        myModal.show()
      })
    },
    selectContractClient: function (id, status, legalIdentifier) {
      this.contractSelected = id
      this.contractStatus = status
      this.legalIdentifierSelected = legalIdentifier
      let urlClientes = "/customer/"
      let query = "?include=seniority"
      if (this.$store.state.roles.Backoffice_member_empresas) {
        urlClientes = "/business" + urlClientes + "get/"
        query = ""
      }
      axios.get(urlClientes + this.legalIdentifierSelected + query).then((response) => {
        // this.$emit("refreshParentList", response.data);
        this.clientInfo = response.data
        var myModal = new ModalBootstrap(
          document.getElementById("clientDataDetail")
        )
        myModal.show()
      })
    },
    renewContract(contractId) {
      axios.get("/contract/" + contractId).then((response) => {
        axios
          .get("/customer/" + response.data.customer.legalIdentifier)
          .then((respuesta) => {
            console.log(respuesta)
            this.$store.commit("setNewContractDataCustomer", respuesta.data)
          })
        this.$store.commit("setContractInfo", response.data)
        this.$router.push({ name: "renewContractStep1" })
      })
    },

    async fetchAndValidateContract(contractId) {
      try {
        this.isLoading = true;
        this.loadingMessage = "Validando datos del contrato...";

        const response = await axios.get('/contract/' + contractId);
        const { paidInstalments, status } = response.data;

        console.log('Detalles del contrato:', { paidInstalments, status });

        if (paidInstalments === 25) {
          const errorMessage = "No se puede ampliar el contrato: ya ha sido ampliado anteriormente.";
          console.error(errorMessage);
          this.showMessage = true;
          this.messageType = "error";
          this.messageContent = errorMessage;
          this.isLoading = false;
          this.loadingMessage = "";
          setTimeout(() => {
            this.showMessage = false;
          }, 5000);
          return null;
        }
        if (paidInstalments !== 24) {
          const errorMessage = `No se puede ampliar el contrato: las cuotas pagadas son ${paidInstalments}, pero deben ser 24.`;
          console.error(errorMessage);
          this.showMessage = true;
          this.messageType = "error";
          this.messageContent = errorMessage;
          this.isLoading = false;
          this.loadingMessage = "";
          setTimeout(() => {
            this.showMessage = false;
          }, 5000);
          return null;
        }
        if (status !== 'CONFIRMED') {
          const errorMessage = `No se puede ampliar el contrato: el estado es ${status}, pero debe ser CONFIRMADO.`;
          console.error(errorMessage);
          this.showMessage = true;
          this.messageType = "error";
          this.messageContent = errorMessage;
          this.isLoading = false;
          this.loadingMessage = "";
          setTimeout(() => {
            this.showMessage = false;
          }, 5000);
          return null;
        }

        this.isLoading = false;
        this.loadingMessage = "";

        return { paidInstalments, status };
      } catch (error) {
        const errorMessage = 'Error al obtener los detalles del contrato: ' + error;
        console.error(errorMessage);
        this.showMessage = true;
        this.messageType = "error";
        this.messageContent = errorMessage;
        this.isLoading = false;
        this.loadingMessage = "";
        setTimeout(() => {
          this.showMessage = false;
        }, 5000);
        return null;
      }
    },

    async extendContract(contract) {
      if (!contract.details) {
        console.error('No se encontraron los detalles del contrato.');
        return;
      }

      const { paidInstalments, status } = contract.details;

      if (paidInstalments === 24) {
        if (status === 'CONFIRMED') {
          this.isLoading = true;
          this.loadingMessage = "Ampliando el contrato...";
          try {
            const response = await axios.post('/contract-extends/order', {
              contractId: contract.contractId,
              isLegacy: true
            });
            console.log('Contrato ampliado con éxito:', response);
            this.showMessage = true;
            this.messageType = "success";
            this.messageContent = "El contrato se ha ampliado exitosamente.";
          } catch (error) {
            const errorMessage = 'Error al ampliar el contrato: ' + error;
            console.error(errorMessage);
            this.showMessage = true;
            this.messageType = "error";
            this.messageContent = errorMessage;
          } finally {
            this.isLoading = false;
            this.loadingMessage = "";
            setTimeout(() => {
              this.showMessage = false;
            }, 5000);
          }
        } else {
          const errorMessage = 'El estado del contrato no es CONFIRMADO. No se puede ampliar el contrato.';
          console.error(errorMessage);
          this.showMessage = true;
          this.messageType = "error";
          this.messageContent = errorMessage;
          setTimeout(() => {
            this.showMessage = false;
          }, 5000);
        }
      } else {
        const errorMessage = 'Las cuotas pagadas no son 24. No se puede ampliar el contrato.';
        console.error(errorMessage);
        this.showMessage = true;
        this.messageType = "error";
        this.messageContent = errorMessage;
        setTimeout(() => {
          this.showMessage = false;
        }, 5000);
      }
    },

    comprobarCancelables(status) {
      let value = false
      if (this.$store.state.roles.Backoffice_supervisor) {
        this.cancelables.forEach((element) => {
          if (element == status) value = true
        })
      } else if (this.$store.state.roles.Backoffice_member) {
        if (status === "UNPAID" || status === "CONFIRMED" || status === "RENOVATED_AND_PURCHASE" ||
        status === "FINISHED_AND_PURCHASE" ||
        status === "FINISHED" ) {
          value = true
        }
      }
      return value
    },
    refreshContractList(item) {
      // Verificar si necesita recarga del servidor
      if (item.needsRefresh && item.contractId) {
        // Marcar el contrato como "procesando" visualmente
        if (this.contractsAux[item.contractIndex]) {
          // Guardar el estado anterior por si necesitamos revertir
          const previousStatus = this.contractsAux[item.contractIndex].status;
          const previousDescription = this.contractsAux[item.contractIndex].statusDescription;

          // Indicar visualmente que est\u00e1 procesando
          this.contractsAux[item.contractIndex].isProcessing = true;

          // Programar recarga del servidor despu\u00e9s de 4 segundos
          setTimeout(async () => {
            try {
              // Obtener el estado real del contrato desde el servidor
              const endpoint = this.$store.state.roles.Backoffice_member_empresas
                ? `/contract/business/${item.contractId}`
                : `/contract/${item.contractId}`;

              const response = await axios.get(endpoint);

              // Actualizar con el estado real del servidor
              if (response.data) {
                this.contractsAux[item.contractIndex].status = response.data.status;
                this.contractsAux[item.contractIndex].statusDescription = response.data.statusDescription || '';

                // Si el estado cambi\u00f3 exitosamente, mostrar mensaje
                if (response.data.status !== previousStatus) {
                  this.showMessage = true;
                  this.messageType = "success";
                  this.messageContent = "Estado del contrato actualizado correctamente";
                }
              }
            } catch (error) {
              console.error('Error al obtener el estado actualizado del contrato:', error);
              // En caso de error, mantener el estado anterior
              this.contractsAux[item.contractIndex].status = previousStatus;
              this.contractsAux[item.contractIndex].statusDescription = previousDescription;

              this.showMessage = true;
              this.messageType = "error";
              this.messageContent = "Error al actualizar el estado del contrato. Por favor, recarga la p\u00e1gina.";
            } finally {
              // Quitar el indicador de procesamiento
              this.contractsAux[item.contractIndex].isProcessing = false;
            }
          }, 4000); // Esperar 4 segundos antes de consultar el estado real
        }
      } else {
        // Mantener compatibilidad con el flujo antiguo si es necesario
        this.contractsAux[item.contractIndex].status = item.cancellation
        this.contractsAux[item.contractIndex].statusDescription = item.description
      }
    },
    async sendManualSendinng(contract, status) {
      const bodyToSend = {
        contractId: contract.contractId,
        status: status
      }
      await axios
        .put(`/contract/request/validate-logistics`, bodyToSend)
        .then(() => {
          this.sucessMessage =
            "Tu solicitud se ha procesado, verás actualizado el estado del contrato."
          this.$emit("refrestContractList")
        })
        .catch(() => {
          this.$emit("errorModal")
        })
    },

    async handleBankReaderAdvance(contractId) {
      this.isLoading = true;
      this.loadingMessage = "Procesando avance de validación BankReader...";

      try {
        const response = await axios.post('/bankreader/callback-manual', {
          contractId: contractId,
          isCallbackManual: true
        });

        if (response.status === 200 || response.status === 201) {
          // Actualizar el contrato en la lista
          const contract = this.contractsAux.find((c) => c.contractId === contractId || c.businessContractId === contractId);
          if (contract) {
            contract.status = 'BANK_READER_CALLBACK_PROCESSED';
            contract.statusDescription = 'Callback BankReader Procesado';
          }

          this.closeDropdown();
          
          // Mostrar notificación de éxito
          this.showMessage = true;
          this.messageType = "success";
          this.messageContent = "Callback manual de BankReader procesado exitosamente";
          
          // Debug: Verificar que las variables se están estableciendo
          console.log('Mostrando notificación de éxito:', {
            showMessage: this.showMessage,
            messageType: this.messageType,
            messageContent: this.messageContent
          });
          
          // Ocultar mensaje después de un tiempo
          setTimeout(() => {
            this.showMessage = false;
            console.log('Ocultando notificación');
          }, 5000);
        }
        
      } catch (error) {
        console.error("Error al avanzar validación de BankReader:", error);
        
        // Manejar diferentes tipos de errores
        const errorData = error.response?.data;
        let errorMessage = "Error al procesar la validación de BankReader";
        
        if (error.response?.status === 404) {
          errorMessage = "❌ No se encontró el contrato especificado";
        } else if (error.response?.status === 400) {
          errorMessage = "❌ El contrato no está en un estado válido para esta operación";
        } else if (error.response?.status === 401 || error.response?.status === 403) {
          errorMessage = "❌ No tienes permisos para realizar esta acción";
        } else if (error.response?.status === 500) {
          errorMessage = "❌ Error interno del servidor BankReader";
        } else if (errorData?.message) {
          errorMessage = `❌ ${errorData.message}`;
        } else if (error.message) {
          errorMessage = `❌ ${error.message}`;
        }
        
        this.showMessage = true;
        this.messageType = "error";
        this.messageContent = errorMessage;
        
        // Cerrar el modal dropdown también en caso de error
        this.closeDropdown();
        
        setTimeout(() => {
          this.showMessage = false;
        }, 5000);
        
      } finally {
        this.isLoading = false;
        this.loadingMessage = "";
      }
    },
    
    closeDropdown() {
      // Método más robusto para cerrar dropdowns de Bootstrap
      this.$nextTick(() => {
        try {
          // Intentar usar Bootstrap API si está disponible
          if (window.bootstrap && window.bootstrap.Dropdown) {
            const dropdownElements = document.querySelectorAll('[data-toggle="dropdown"]');
            dropdownElements.forEach(element => {
              const dropdown = window.bootstrap.Dropdown.getInstance(element);
              if (dropdown) {
                dropdown.hide();
              }
            });
          }
        } catch (e) {
          console.log('Bootstrap API no disponible, usando método manual');
        }
        
        // Método manual como fallback
        // 1. Cerrar todos los dropdowns abiertos
        const dropdowns = document.querySelectorAll('.dropdown-menu.show');
        dropdowns.forEach(dropdown => {
          dropdown.classList.remove('show');
          // Remover el atributo aria-expanded del toggle
          const toggle = dropdown.previousElementSibling;
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
            toggle.classList.remove('show');
          }
        });
        
        // 2. Remover todos los backdrops existentes
        const backdrops = document.querySelectorAll('.modal-backdrop');
        backdrops.forEach(backdrop => {
          backdrop.remove();
        });
        
        // 3. Limpiar el body completamente
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        document.body.style.paddingLeft = '';
        
        // 4. Forzar reflow y limpiar cualquier estilo residual
        document.body.offsetHeight;
        
        // 5. Disparar evento personalizado para notificar que se cerró
        window.dispatchEvent(new CustomEvent('dropdownClosed'));
        
        console.log('Dropdown cerrado y backdrop removido correctamente');
      });
    },
    updateContractStatus({ contractId, status, statusDescription }) {
      const contract = this.contractsAux.find((c) => c.contractId === contractId);
      if (contract) {
        contract.status = status;
        contract.statusDescription = statusDescription;
      }
    },
    async handleScoringStoreAction(contractId, status) {
      try {
        this.isLoading = true;
        this.loadingMessage = "Procesando solicitud...";

        const response = await axios.patch('/bff/salesflow/callback-scoring-store', {
          contractId: contractId,
          status: status
        });

        if (response.status === 200) {
          this.showMessage = true;
          this.messageType = "success";
          this.messageContent = `Scoring de tienda ${status === 'ACCEPTED' ? 'aceptado' : 'denegado'} correctamente`;

          // Actualizar el estado del contrato en la lista
          const contract = this.contractsAux.find(c => c.contractId === contractId);
          if (contract) {
            contract.status = status === 'ACCEPTED' ? 'SCORING_PASSED' : 'DENIED_SCORING_STORE';
            contract.statusDescription = status === 'ACCEPTED' ? 'Scoring Aceptado' : 'Scoring Denegado';
          }
        }
      } catch (error) {
        console.error('Error al procesar la solicitud:', error);
        this.showMessage = true;
        this.messageType = "error";
        this.messageContent = "Error al procesar la solicitud. Por favor, intente nuevamente.";
      } finally {
        this.isLoading = false;
        this.loadingMessage = "";
        setTimeout(() => {
          this.showMessage = false;
        }, 5000);
      }
    },
    handleReplacementSuccess(data) {
      this.showMessage = true;
      this.messageType = "success";
      this.messageContent = `Reemplazo solicitado correctamente para el contrato ${data.contractId}`;
      this.showModalReplacement = false;

      setTimeout(() => {
        this.showMessage = false;
      }, 5000);
    },
    /**
     * Avanzar H - Envía el contrato a Hocelot para validación de duplicados
     * Utiliza el estado PROCEED_HOCELOT para que el backend:
     * - Valide si ya tiene resultado de Hocelot OK -> avanza el contrato
     * - Si no tiene resultado, llama a Hocelot
     * - Si Hocelot retorna KO, deniega al estado correspondiente
     */
    async handleHocelotAdvance(contractId) {
      try {
        this.isLoading = true;
        this.loadingMessage = "Enviando contrato a Hocelot para validación...";

        const response = await axios.put('/contract/validation/update-status', {
          contractId: contractId,
          status: 'PROCEED_HOCELOT',
          blacklist: false
        });

        if (response.status === 200) {
          this.showMessage = true;
          this.messageType = "success";
          this.messageContent = "Contrato enviado a Hocelot correctamente";

          this.closeDropdown();

          // Refrescar la lista para obtener el nuevo estado
          this.$emit("sendRefreshRegisterList");
        }
      } catch (error) {
        console.error('Error al enviar contrato a Hocelot:', error);

        let errorMessage = "Error al procesar la validación con Hocelot";

        if (error.response?.status === 404) {
          errorMessage = "Endpoint no disponible. Contacte al administrador.";
        } else if (error.response?.status === 400) {
          errorMessage = "El contrato no está en un estado válido para esta operación";
        } else if (error.response?.status === 401 || error.response?.status === 403) {
          errorMessage = "No tienes permisos para realizar esta acción";
        } else if (error.response?.data?.message) {
          errorMessage = error.response.data.message;
        }

        this.showMessage = true;
        this.messageType = "error";
        this.messageContent = errorMessage;
        this.closeDropdown();
      } finally {
        this.isLoading = false;
        this.loadingMessage = "";
        setTimeout(() => {
          this.showMessage = false;
        }, 5000);
      }
    },
    async handlePaymentReceived(businessContractId, contractIndex) {
      try {
        this.isLoading = true;
        this.loadingMessage = "Procesando pago recibido...";

        const bodyToSend = {
          businessContractId: businessContractId,
          status: 'pending_delivery'
        };

        const response = await axios.patch('/business/update-contract', bodyToSend);

        if (response.status === 200) {
          this.showMessage = true;
          this.messageType = "success";
          this.messageContent = "Pago recibido confirmado correctamente";

          // Actualizar el estado del contrato en la lista
          if (this.contractsAux[contractIndex]) {
            this.contractsAux[contractIndex].status = 'pending_delivery';
            this.contractsAux[contractIndex].statusDescription = 'PENDIENTE DE ENTREGA';
          }

          // Cerrar el dropdown
          this.closeDropdown();
        }
      } catch (error) {
        console.error('Error al procesar el pago recibido:', error);
        this.showMessage = true;
        this.messageType = "error";
        this.messageContent = "Error al procesar el pago recibido. Por favor, intente nuevamente.";
        this.closeDropdown();
      } finally {
        this.isLoading = false;
        this.loadingMessage = "";
        setTimeout(() => {
          this.showMessage = false;
        }, 5000);
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
// #clients-list {
//   overflow: auto;
// }
.loading-overlay {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 1050;
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 1rem;
  border-radius: 0.25rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.spinner-border {
  margin-right: 0.5rem;
}

.loading-overlay p {
  margin: 0;
}

.message-overlay {
  position: fixed;
  top: 2rem;
  right: 1rem;
  z-index: 9999;
  background-color: rgba(255, 255, 255, 0.95);
  padding: 1rem 1.5rem;
  border-radius: 0.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  min-width: 300px;
  max-width: 500px;
  animation: slideInRight 0.3s ease-out;
}

.message-overlay p {
  margin: 0;
  margin-right: 1rem;
  font-weight: 500;
  font-size: 0.95rem;
}

.message-overlay.success {
  border-left: 5px solid #28a745;
  background-color: rgba(40, 167, 69, 0.8);
  border: 1px solid #28a745;
  color: #fff;
}

.message-overlay.error {
  border-left: 5px solid #dc3545;
  background-color: rgba(220, 53, 69, 0.8);
  border: 1px solid #dc3545;
  color: #fff;
}

.message-overlay.info {
  border-left: 5px solid #17a2b8;
  background-color: rgba(23, 162, 184, 0.8);
  border: 1px solid #17a2b8;
  color: #fff;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
.list-item h4 {
  font-size: 1rem;
}

#operaciones {
  text-align: right;
}

thead {
  background-color: rgb(250, 250, 250);
}

td {
  max-width: 15em;
}

th {
  max-width: 18em;
}

.col-12 {
  padding: 0%;
}
</style>
